<template>
  <div class="page">
    <!-- 桌面端：>1024px 显示 PcComponent -->
    <PcComponent v-if="isDesktop" />
    <!-- 平板/移动端：≤1024px 显示 H5Component -->
    <H5Component v-else />
  </div>
</template>

<script>
import PcComponent from "../components/PcComponent.vue";
import H5Component from "../components/H5Component.vue";
import { isDesktop } from "../utils/breakpoint";

export default {
  components: { PcComponent, H5Component },
  data() {
    return {
      isDesktop: false,
    };
  },
  methods: {
    // 更新断点状态
    updateBreakpoint() {
      this.isDesktop = isDesktop();
    },
  },
  mounted() {
    // 初始化状态
    this.updateBreakpoint();
    // 监听窗口大小变化（适配旋转、缩放等场景）
    window.addEventListener("resize", this.updateBreakpoint);
  },
  beforeDestroy() {
    // 移除监听，避免内存泄漏
    window.removeEventListener("resize", this.updateBreakpoint);
  },
};
</script>
